import { extendTheme } from '@chakra-ui/react';
import { colors } from './colors';

export const theme = extendTheme({
  colors,
  fonts: {
    heading: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  radii: {
    card: '20px',
    button: '14px',
    input: '14px',
    modal: '24px',
  },
  shadows: {
    soft: '0px 10px 30px rgba(0, 0, 0, 0.04)',
    glass: '0 8px 32px 0 rgba(31, 38, 135, 0.07)',
    glowPrimary: '0px 8px 25px rgba(255, 77, 109, 0.35)',
    glowSecondary: '0px 8px 25px rgba(108, 99, 255, 0.35)',
  },
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === 'dark' ? '#0B0F17' : '#F8FAFC',
        color: props.colorMode === 'dark' ? '#F8FAFC' : '#0F172A',
        transitionProperty: 'background-color, color',
        transitionDuration: '0.2s',
        overflowX: 'hidden',
      },
      '*::-webkit-scrollbar': {
        width: '6px',
        height: '6px',
      },
      '*::-webkit-scrollbar-thumb': {
        background: props.colorMode === 'dark' ? '#2D3748' : '#CBD5E1',
        borderRadius: '10px',
      },
      '*::-webkit-scrollbar-track': {
        background: 'transparent',
      },
    }),
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: '14px',
        fontWeight: '600',
        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
      },
      variants: {
        gradientPrimary: {
          bgGradient: 'linear(to-r, #FF4D6D, #FF758F)',
          color: 'white',
          _hover: {
            bgGradient: 'linear(to-r, #E03152, #FF4D6D)',
            transform: 'translateY(-2px)',
            boxShadow: '0px 8px 25px rgba(255, 77, 109, 0.35)',
          },
          _active: {
            transform: 'translateY(0)',
          },
        },
        gradientSecondary: {
          bgGradient: 'linear(to-r, #6C63FF, #9470FF)',
          color: 'white',
          _hover: {
            bgGradient: 'linear(to-r, #5849E0, #6C63FF)',
            transform: 'translateY(-2px)',
            boxShadow: '0px 8px 25px rgba(108, 99, 255, 0.35)',
          },
        },
        glass: (props) => ({
          bg: props.colorMode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(12px)',
          border: '1px solid',
          borderColor: props.colorMode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(226, 232, 240, 0.8)',
          _hover: {
            bg: props.colorMode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.9)',
          },
        }),
      },
    },
    Card: {
      baseStyle: (props) => ({
        container: {
          borderRadius: '20px',
          bg: props.colorMode === 'dark' ? '#161F30' : '#FFFFFF',
          border: '1px solid',
          borderColor: props.colorMode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(226, 232, 240, 0.8)',
          boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.04)',
          backdropFilter: 'blur(16px)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        },
      }),
    },
  },
});
